import React, { useState, useContext, useEffect } from 'react';
import Modal from './index';
import { ModalContext } from '../ModalContext';
import { useForm, Resolver, Controller } from "react-hook-form"
import API from '../API'
import { AdminAddPersonToProjectFunction, AdminDeleteEntryType, AdminReloadFunction, AdminUpdateEntryType } from '../interfaces';
import { getDayOfWeekName, lookupNameFromObjectsArray } from '../global'
import { SaveDayResponse, ReportingData, ReportingDataDay, DeleteDayResponse, QueryTimeReportRows, AdminPersonMonthReport, AdminPersonsResponse, AdminProjectPersonsResponse, InitData } from '../../../backend/src/api/dto';
import DatePicker from 'react-datepicker';

type FormValues = {
    orderId: number | string
}




function UserAddTimeReportRow({ item, reload, alreadyAdded, addFunction, initData }: {
    item: any,
    reload: AdminReloadFunction,
    alreadyAdded: QueryTimeReportRows[],
    addFunction: Function,
    initData: InitData,
}) {

    const [showModal, closeModal] = useContext(ModalContext);
    const { register, control, handleSubmit, getValues, } = useForm<FormValues>({
        defaultValues: {
            // startDate: '',
            // endDate: ''
        }
    })

    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);
    const [data, setData] = useState<AdminPersonsResponse>();
    const [apiResult, setApiResult] = useState<null | { status: boolean }>(null)


    // useEffect(() => {
    //     API.getPersons().then(data => {
    //         setData(data)
    //     })
    // }, [])

    const modalButtons = [
        {
            text: 'Confirm',
            icon: 'check',
            onClick: () => onSubmit(),

            style: 'primary'
        }, {
            text: 'Cancel',
            icon: 'xmark',
            onClick: 'closeModal',
            style: 'secondary'
        }
    ];


    const onSubmit = () => {
        const form = getValues();


        setSending(true);
        return new Promise((resolve, reject) => {
            handleSubmit((data) => {
                //  console.log({ data: getValues() })


                setLoading(false);
                setApiResult({
                    status: true,
                })
                addFunction(data.orderId).then(() => {

                    closeModal(null);
                    resolve(1)

                }).catch((e: any) => {
                    setLoading(false);
                    setApiResult(e)
                    resolve(1)
                })



                setSending(false)
            })()
        })

    }





    return (



        <Modal
            buttons={modalButtons}
            title={'Pridať riadok '}
            errorObject={apiResult}
            disableAllButtons={sending}
        >
            <form style={{ minHeight: '300px' }}>
                <div className="row mb-2">
                    <div className="col-4 text-end mt-2">
                        Pridať
                    </div>
                    <div className="col-8">
                        <select className="form-select" {...register("orderId")} >
                            <option value="">[ Vybrať ]</option>
                            {
                                initData.specialProjects.filter(project => {
                                    return alreadyAdded.findIndex(item => item.projectId === project.projectId && item.orderId === project.orderId) === -1
                                }).map(project => {
                                    return (
                                        <option value={ project.orderId}>{project.projectName} : {project.orderName}</option>
                                    )
                                })
                            }
                        </select>
                    </div>
                </div>
            </form>
        </Modal>


    )

}

export default UserAddTimeReportRow
